export enum SUB_WEBSITE {
  SUB_WEBSITE_ID_MAIN = 0,
  SUB_WEBSITE_ID_TURKEY = 177,
  SUB_WEBSITE_ID_MALTA = 106,
  SUB_WEBSITE_ID_HONGKONG = 71,
  SUB_WEBSITE_ID_US = 232,
  SUB_WEBSITE_ID_BS = 14,
  SUB_WEBSITE_ID_SP = 153,
  SUB_WEBSITE_ID_UK = 182,
  SUB_WEBSITE_ID_JP = 83,
  SUB_WEBSITE_ID_UAE = 181,
  SUB_WEBSITE_ID_TEST_NET = 666,
  SUB_WEBSITE_ID_EU = 777,
}

// vip icon path
export const vipIconPrefixPath = `${process.env.NEXT_PUBLIC_PREFIX}/static/images/vip-3.1-icon/` /* VIP0.webp */
export const vipDiamondIconPrefixPath = `${process.env.NEXT_PUBLIC_PREFIX}/static/images/vip-diamond-icon/` /* VIP0.webp */

// coin icon domain
export const baseImageDomainUrl = 'https://icon.gateimg.com/'

// mt domain
export const MT_DOMAIN = 'https://www.gate.mt'

export const GET_LOGIN_USER = '/api/web/v1/usercenter/get_info'
export const GET_USER_TIER_INFO = '/api/web/v1/usercenter/get_user_tier'
export const GET_SITE_SETTINGS = '/api/web/v1/site/settings'
export const GET_COMPLIANCE_CHECK = '/api/web/v1/compliance/check'
export const GET_TOTAL_FUNDS = '/apiw/v2/account/total_funds'
export const GET_FOOTER_TIPS_CHECK = '/api/web/v1/kyc/footerTipsCheck'
export const GET_ICON_WHITELIST = '/js/tool/coin_icon_whitelist.json'
export const GET_PAGE_DOWNLOAD_LINKS = '/js/tool/page_download_links.json'

// 社媒分享默认图片地址
export const DEFAULT_OG_IMAGE_URL =
  process.env.OG_IMAGE_URL || 'https://gimg2.gateimg.com/image/1744374884510042263-20250411-203131.webp'
